module.exports = __webpack_public_path__ + "img/keliumao-banner.0fc1d99a.png";